import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import api from "@/lib/api";

export function searchUrl(q, category = "", focus = "") {
  const p = new URLSearchParams({ q: q.trim() });
  if (category) p.set("category", category);
  if (focus) p.set("focus", focus);
  return "/pencarian?" + p.toString();
}

export default function GlobalDataSearch() {
  const [term, setTerm] = useState("");
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const nav = useNavigate();
  const location = useLocation();
  const requestId = useRef(0);

  useEffect(() => {
    setActive(false);
    setMatches([]);
    setTerm("");
  }, [location.pathname, location.search]);

  useEffect(() => {
    const q = term.trim();
    const id = ++requestId.current;
    if (q.length < 2) { setMatches([]); setLoading(false); return; }
    setLoading(true);
    const timer = setTimeout(() => {
      api.get("/global-search", { params: { q } })
        .then(r => { if (requestId.current === id) setMatches(r.data?.results || []); })
        .catch(() => { if (requestId.current === id) setMatches([]); })
        .finally(() => { if (requestId.current === id) setLoading(false); });
    }, 260);
    return () => clearTimeout(timer);
  }, [term]);

  const go = (category="", focus="") => {
    const q = term.trim();
    if (q.length < 2) return;
    setActive(false);
    nav(searchUrl(q, category, focus));
  };

  return <form
    data-testid="global-data-search-form"
    className="erp-global-search relative flex-1 min-w-0 max-w-[545px]"
    role="search"
    onSubmit={e => { e.preventDefault(); go(); }}
    onBlur={e => {
      if (!e.currentTarget.contains(e.relatedTarget)) setActive(false);
    }}
  >
    <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none" />
    <input
      data-testid="global-menu-search"
      aria-label="Cari data ERP"
      autoComplete="off"
      value={term}
      onChange={e => { setTerm(e.target.value); setActive(true); }}
      onFocus={() => setActive(true)}
      onKeyDown={e => { if (e.key === "Escape") setActive(false); }}
      placeholder="Cari pelanggan, setoran, data..."
      className="w-full h-10 rounded-xl border border-slate-200 bg-white/95 pl-10 pr-3 text-sm text-slate-700 outline-none transition focus:border-blue-400 focus:ring-4 focus:ring-blue-100"
    />
    {active && term.trim().length >= 2 && <div
      data-testid="global-data-search-dropdown"
      className="absolute left-0 right-0 top-[46px] max-h-[60vh] overflow-y-auto rounded-xl border border-slate-200 bg-white p-2 shadow-xl z-50"
    >
      {loading && <div className="px-3 py-2 text-xs text-slate-500">Mencari data sesuai akses...</div>}
      {!loading && matches.length === 0 && <div className="px-3 py-2 text-xs text-slate-500">Data tidak ditemukan. Coba nama, nomor setoran, atau tanggal.</div>}
      {!loading && matches.slice(0, 9).map((item, i) => <button
        type="button"
        key={item.type + ":" + item.id + ":" + i}
        data-testid={"global-data-hit-" + i}
        onClick={() => go(item.type, item.id)}
        className="block w-full rounded-lg px-3 py-2 text-left text-sm hover:bg-slate-50"
      >
        <span className="block text-[10px] font-semibold uppercase tracking-wide text-blue-700">{item.label}</span>
        <span className="block font-semibold text-slate-800 truncate">{item.title}</span>
        <span className="block text-xs text-slate-500 truncate">{item.subtitle}</span>
      </button>)}
      <button type="submit" className="block w-full text-center text-sm font-semibold text-[#00558F] border-t mt-1 pt-2 pb-1">
        Lihat semua hasil pencarian
      </button>
    </div>}
  </form>;
}
